import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headgirl',
  templateUrl: './headgirl.component.html',
  styleUrls: ['./headgirl.component.css']
})
export class HeadgirlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
